import React, { FunctionComponent, useEffect, useState } from 'react';
import { classNames } from '../../../utils/class-names';
import { StoryTweet } from './story-tweet';

export interface StoryTweetCardProps {
  tweet: StoryTweet;
  openClickCommand?: () => void;
  showLabel?: boolean;
}

export const StoryTweetCard: FunctionComponent<StoryTweetCardProps> = ({
  tweet,
  openClickCommand,
  showLabel = true,
}) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setTimeout(() => setExpanded(true), 0);
  }, [setExpanded]);

  const onClick = () => {
    if (openClickCommand) {
      openClickCommand();
    }
  };

  const getLabel = () => {
    if (!showLabel) return;
    return (
      <div className="mb-2 text-left font-['Ubuntu'] text-[12px] font-bold leading-4 tracking-[0.5px] text-black">
        What people are saying...
      </div>
    );
  };

  if (!tweet) {
    return <div />;
  }

  return (
    <div
      className={classNames(
        'mt-[15px] origin-top-left border-l-[3px] border-gray-300 bg-white px-[15px] py-[5px] text-[13px] leading-[18px] transition-all duration-1000',
        expanded ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
      )}
    >
      {getLabel()}
      <div className="mt-1 flex items-start">
        <div>
          <img
            className="w-9 cursor-pointer rounded-full align-middle"
            src={tweet.imageUrl}
            alt="Not available"
            onClick={() => onClick()}
          />
        </div>
        <div className="ml-2 line-clamp-3 flex-1 text-[12px] leading-4">
          <span
            className="mr-1 cursor-pointer font-bold text-primary-deep"
            onClick={() => onClick()}
          >
            {tweet.name}
          </span>
          <span dangerouslySetInnerHTML={{ __html: tweet.bodyHtml }} />
        </div>
      </div>
    </div>
  );
};
